"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Command = Command;
exports.CommandComboboxInput = CommandComboboxInput;
exports.CommandDialog = CommandDialog;
exports.CommandEmpty = CommandEmpty;
exports.CommandGroup = CommandGroup;
exports.CommandInput = CommandInput;
exports.CommandItem = CommandItem;
exports.CommandList = CommandList;
exports.CommandSeparator = CommandSeparator;
exports.CommandShortcut = CommandShortcut;
var React = _interopRequireWildcard(require("react"));
var _cmdk = require("cmdk");
var _utils = require("@design/lib/utils");
var _checkbox = require("@design/ui/checkbox");
var _dialog = require("@design/ui/dialog");
var _inputGroup = require("@design/ui/input-group");
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["title", "description", "children", "className", "showCloseButton"],
  _excluded3 = ["className"],
  _excluded4 = ["className", "autoFocus"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className", "children", "checkbox"],
  _excluded9 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Command(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command, _objectSpread(_objectSpread({
    "data-slot": "command",
    className: (0, _utils.cn)("flex size-full flex-col overflow-hidden rounded-xl! bg-popover p-1 text-popover-foreground", className)
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive",
    "data-sentry-component": "Command",
    "data-sentry-source-file": "command.tsx"
  }));
}
function CommandDialog(_ref2) {
  var _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? "Command Palette" : _ref2$title,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? "Search for a command to run..." : _ref2$description,
    children = _ref2.children,
    className = _ref2.className,
    _ref2$showCloseButton = _ref2.showCloseButton,
    showCloseButton = _ref2$showCloseButton === void 0 ? false : _ref2$showCloseButton,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.Dialog, _objectSpread(_objectSpread({}, props), {}, {
    "data-sentry-element": "Dialog",
    "data-sentry-component": "CommandDialog",
    "data-sentry-source-file": "command.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogHeader, {
      className: "sr-only",
      "data-sentry-element": "DialogHeader",
      "data-sentry-source-file": "command.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
        "data-sentry-element": "DialogTitle",
        "data-sentry-source-file": "command.tsx",
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogDescription, {
        "data-sentry-element": "DialogDescription",
        "data-sentry-source-file": "command.tsx",
        children: description
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogContent, {
      className: (0, _utils.cn)("top-1/3 translate-y-0 overflow-hidden rounded-xl! p-0", className),
      showCloseButton: showCloseButton,
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "command.tsx",
      children: children
    })]
  }));
}
function CommandInput(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-slot": "command-input-wrapper",
    className: "p-1 pb-0",
    "data-sentry-component": "CommandInput",
    "data-sentry-source-file": "command.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroup, {
      className: "rounded-none border-0 border-b border-border-default bg-background-canvas shadow-none dark:bg-background-canvas focus-within:border-border-focus has-[>[data-align=inline-start]]:[&>input]:pl-2",
      "data-sentry-element": "InputGroup",
      "data-sentry-source-file": "command.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command.Input, _objectSpread(_objectSpread({
        "data-slot": "command-input",
        className: (0, _utils.cn)("w-full border-0 bg-transparent text-sm shadow-none ring-0 outline-hidden disabled:cursor-not-allowed disabled:opacity-50", className)
      }, props), {}, {
        "data-sentry-element": "CommandPrimitive.Input",
        "data-sentry-source-file": "command.tsx"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, {
        "data-sentry-element": "InputGroupAddon",
        "data-sentry-source-file": "command.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SearchIcon, {
          className: "size-4 shrink-0 opacity-50",
          "data-sentry-element": "SearchIcon",
          "data-sentry-source-file": "command.tsx"
        })
      })]
    })
  });
}
function CommandComboboxInput(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command.Input, _objectSpread(_objectSpread({
    asChild: true
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive.Input",
    "data-sentry-component": "CommandComboboxInput",
    "data-sentry-source-file": "command.tsx"
  }));
}
function CommandList(_ref4) {
  var className = _ref4.className,
    autoFocus = _ref4.autoFocus,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var listRef = React.useRef(null);
  React.useEffect(function () {
    var _listRef$current;
    if (autoFocus) (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.focus();
  }, [autoFocus]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command.List, _objectSpread(_objectSpread({
    ref: listRef,
    "data-slot": "command-list",
    className: (0, _utils.cn)("no-scrollbar max-h-72 scroll-py-1 overflow-x-hidden overflow-y-auto outline-none", className)
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive.List",
    "data-sentry-component": "CommandList",
    "data-sentry-source-file": "command.tsx"
  }));
}
function CommandEmpty(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command.Empty, _objectSpread(_objectSpread({
    "data-slot": "command-empty",
    className: (0, _utils.cn)("py-6 text-center text-sm", className)
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive.Empty",
    "data-sentry-component": "CommandEmpty",
    "data-sentry-source-file": "command.tsx"
  }));
}
function CommandGroup(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command.Group, _objectSpread(_objectSpread({
    "data-slot": "command-group",
    className: (0, _utils.cn)("overflow-hidden p-1 text-foreground **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive.Group",
    "data-sentry-component": "CommandGroup",
    "data-sentry-source-file": "command.tsx"
  }));
}
function CommandSeparator(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_cmdk.Command.Separator, _objectSpread(_objectSpread({
    "data-slot": "command-separator",
    className: (0, _utils.cn)("-mx-1 h-px w-auto bg-border", className)
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive.Separator",
    "data-sentry-component": "CommandSeparator",
    "data-sentry-source-file": "command.tsx"
  }));
}
function CommandItem(_ref8) {
  var className = _ref8.className,
    children = _ref8.children,
    checkbox = _ref8.checkbox,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_cmdk.Command.Item, _objectSpread(_objectSpread({
    "data-slot": "command-item",
    className: (0, _utils.cn)("group/command-item relative flex cursor-default items-center gap-2 rounded-lg p-2 text-sm outline-hidden select-none in-data-[slot=dialog-content]:rounded-lg! data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 data-[selected=true]:bg-muted data-[selected=true]:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[selected=true]:**:[svg]:not-in-data-[slot=checkbox]:text-foreground", className),
    "aria-checked": checkbox
  }, props), {}, {
    "data-sentry-element": "CommandPrimitive.Item",
    "data-sentry-component": "CommandItem",
    "data-sentry-source-file": "command.tsx",
    children: [checkbox !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
      checked: checkbox,
      tabIndex: -1,
      "aria-hidden": true,
      className: "pointer-events-none"
    }), children, checkbox === undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      className: "ml-auto opacity-0 group-has-data-[slot=command-shortcut]/command-item:hidden group-data-[checked=true]/command-item:opacity-100"
    })]
  }));
}
function CommandShortcut(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
    "data-slot": "command-shortcut",
    className: (0, _utils.cn)("ml-auto text-xs tracking-widest text-muted-foreground group-data-[selected=true]/command-item:text-foreground", className)
  }, props), {}, {
    "data-sentry-component": "CommandShortcut",
    "data-sentry-source-file": "command.tsx"
  }));
}